import { Controller } from "@hotwired/stimulus";

/**
 * ApplyCouponController handles applying a coupon code on the public signup page.
 */
export default class extends Controller {
  static targets = ['input'];
  static values = { url: String };

  redeem() {
    this.element.setAttribute('src', `${this.urlValue}?code=${this.inputTarget.value}`);
  }

  // This captures the enter key to apply the coupon instead of submitting the form
  captureEnter(event) {
    if(event.keyCode == 13) {
      event.preventDefault();
      this.redeem();
    }
  }
};
